/**
 * ISOs Page — Phase 5b Placeholder
 *
 * Placeholder page for ISO management functionality.
 * Will be fully implemented in future phases.
 */

import React from 'react';
import { COLORS, TYPOGRAPHY, SPACING, RADIUS, SHADOWS, STYLES } from '../designSystem';

export default function ISOs() {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>ISOs</h1>
          <p style={styles.subtitle}>Manage ISO partners and relationships</p>
        </div>
      </div>

      <div style={styles.placeholderCard}>
        <div style={styles.iconContainer}>
          <div style={styles.icon}>🤝</div>
        </div>
        <h2 style={styles.placeholderTitle}>ISO Management Coming Soon</h2>
        <p style={styles.placeholderText}>
          This section will allow you to manage ISO partners and track relationships.
          Full functionality is being prepared and will be available in the next update.
        </p>
        <p style={styles.placeholderSubtext}>
          For now, you can manage deals and merchants through the main navigation.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    ...STYLES.pageContainer,
  },

  header: {
    maxWidth: '1400px',
    margin: '0 auto 48px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingBottom: SPACING.LG,
    borderBottom: `1px solid ${COLORS.BORDER_LIGHT}`,
  },

  title: {
    ...TYPOGRAPHY.H1,
    color: COLORS.TEXT_PRIMARY,
    margin: 0,
    marginBottom: SPACING.SM,
  },

  subtitle: {
    ...TYPOGRAPHY.BODY,
    color: COLORS.TEXT_LIGHT,
    margin: 0,
  },

  placeholderCard: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: SPACING.XXXL,
    backgroundColor: COLORS.BG_WHITE,
    borderRadius: RADIUS.DEFAULT,
    boxShadow: SHADOWS.DEFAULT,
    textAlign: 'center',
    border: `1px solid ${COLORS.BORDER_LIGHT}`,
  },

  iconContainer: {
    marginBottom: SPACING.XL,
  },

  icon: {
    fontSize: '64px',
    display: 'inline-block',
  },

  placeholderTitle: {
    ...TYPOGRAPHY.H2,
    color: COLORS.TEXT_PRIMARY,
    margin: 0,
    marginBottom: SPACING.MD,
  },

  placeholderText: {
    ...TYPOGRAPHY.BODY,
    color: COLORS.TEXT_LIGHT,
    margin: 0,
    marginBottom: SPACING.MD,
  },

  placeholderSubtext: {
    ...TYPOGRAPHY.BODY_SM,
    color: COLORS.TEXT_LIGHT,
    margin: 0,
    fontStyle: 'italic',
  },
};
